// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_oq-0";
export var buttonContainer = "_oq-3";
export var cancelButton = "_oq-4";
export var headerSection = "_oq-6";
export var headerTitle = "_oq-9";
export var messageSideLeft = "_oq-1";
export var messageSideRight = "_oq-2";
export var orderNumberContainer = "_oq-7";
export var orderNumberLabel = "_oq-8";
export var submitButton = "_oq-5";